import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteSpecialDaySlice = createSlice({
  name: 'DeleteSpecialDay',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteSpecialDay: (state, _) => {
      state.isLoading = true;
    },
    successDeleteSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteSpecialDay: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSpecialDay,
  failureDeleteSpecialDay,
  successDeleteSpecialDay,
  clearDeleteSpecialDay,
} = DeleteSpecialDaySlice.actions;

export default DeleteSpecialDaySlice.reducer;
